import axios from 'axios'
import qs from 'qs'
import vue from  '../../main'

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';        //配置请求头
axios.defaults.baseURL = 'https://stuapi.kidcastle.cn'   //配置接口地址

//POST传参序列化(添加请求拦截器)
axios.interceptors.request.use((config) => {
    let oldUrl = config.url
    let token = '';
    if(localStorage.lang == 1){
        config.baseURL = 'https://stuapi.kidcastleapp.tw'
    }

    // JSON参数
    if(config.method  === 'post'){
        config.data = qs.stringify(config.data);
    }
    //请求带token
    if (localStorage.getItem("token")) {
        token = localStorage.getItem("token")
    }

    config.url = oldUrl;

    return config;
},(error) =>{
    console.log('错误的传参')
    return Promise.reject(error);
});

//返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) =>{
    if(res.data.errortip == 'tokenfailure'){
        vue.$router.push('/login')
    }
    //对响应数据做些事
    if(!res.data.success){
        return Promise.resolve(res);
    }
    return res;
}, (error) => {
    console.log('网络错误')
    vue.$alert('<p>网络错误</p>', {
        dangerouslyUseHTMLString: true,
        customClass:'warning',
        showConfirmButton:false,
        closeOnClickModal:true
    })
    return Promise.reject(error);
});

//返回一个Promise(发送post请求)
export function fetchPost(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params)
            .then(response => {
                resolve(response);
            }, err => {
                reject(err);
            })
            .catch((error) => {
                reject(error)
            })
    })
}
//返回一个Promise(发送get请求)
export function fetchGet(url, param) {
    return new Promise((resolve, reject) => {
        axios.get(url, {params: param})
            .then(response => {
                resolve(response)
            }, err => {
                reject(err)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
export default {
    fetchPost,
    fetchGet,
}



// WEBPACK FOOTER //
// ./src/assets/js/http.js